<template>
  <div class="col-md-12 user_list card_flex">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form filter">
        <div class="filter_item">
          <fg-input
            v-model="filter.searched_user"
            type="text"
            class="search_user"
            :clearable="true"
            placeholder="Name, login, email or phone"
            :label="translate('user.search_user')"
            @input="change_input"
          />
        </div>

        <div class="filter_item">
          <label> {{ translate("user.users_state") }} </label>
          <tree-select
            :options="user_status"
            :multiple="false"
            v-model="filter.status"
            :placeholder="translate('device.group.many')"
            :clearable="false"
            @input="change_input"
          />
        </div>

        <div class="filter_item" v-if="$store.getters.getClientsList.length > 0">
          <label> {{ translate("client.one") }} </label>
          <tree-select
            :options="client_list"
            :placeholder="translate('client.one')"
            v-model="filter.client_id"
            :multiple="false"
            @input="change_input"
          />
        </div>
        <div class="filter_item"></div>
      </div>


      <div class="buttons">
        <span
          class="btn btn-warning btn-fill reset_filter"
          @click.prevent="clear_filter()"
        >
          <b>{{ translate("user.reset_filter") }}</b>
        </span>

        <span
          v-if="$store.getters.getPermissions.createUser === true"
          class="mdi mdi-plus-circle-outline btn btn-success btn-fill new_user"
          @click.prevent="new_user({})"
        >
          <b>{{ translate("user.to_add") }}</b>
        </span>
      </div>
    </div>

    <div class="response_table card_table">
      <table>
        <thead style="flex: 0">
          <tr>
            <th scope="col" style="width: 40px">ID</th>
            <th scope="col" class="w12per text-left">
              {{ translate("user.name") }}
            </th>
            <th scope="col" class="w10per text-left">
              {{ translate("user.login") }}
            </th>
            <th scope="col" class="w12per text-left">email</th>
            <th scope="col" class="w10per text-left">
              {{ translate("user.client") }}
            </th>
            <th scope="col" class="text-left">
              {{ translate("device.group.many") }}
            </th>
            <th v-if="$store.getters.getPermissions.permissionGod" scope="col" class="text-left">
              {{ translate('user.roles.many') }}
            </th>
            <th scope="col" class="w10per text-right">
              {{ translate("user.last_try_ts") }}
            </th>
            <th scope="col" style="width: 10px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border: none; background-color: transparent">
            <td><scale-loader /></td>
          </tr>
          <router-link
            :to="'/user/' + user.id"
            v-for="(user, key) in users"
            :key="key"
          >
            <tr class="user">
              <td data-label="ID" style="width: 40px">
                {{ user.id }}
              </td>
              <td class="w12per text-left" :data-label="translate('user.name')">
                {{ user.name }}
              </td>
              <td class="w10per text-left" :data-label="translate('user.login')">
                {{ user.username }}
              </td>
              <td data-label="email" class="w12per text-left">
                {{ user.email }}
              </td>
              <td class="w10per text-left" :data-label="translate('user.client')" @click.stop="">
                <router-link :to="'/client/' + user.client_id">
                  {{ user_client(user.client_id) }}
                </router-link>
              </td>
              <td class="text-left" :data-label="translate('user.groups')">
                <div class="user_budge">
                  <span
                      v-for="(group, group_key) in user_groups(
                    user.user_device_groups
                  )"
                      :key="group_key"
                      class="user_budge__item"
                  >
                    {{ group }}
                  </span>
                </div>
              </td>
              <td class="text-left" v-if="$store.getters.getPermissions.permissionGod" :data-label="translate('user.roles.many')">
                <div class="user_budge">
                  <span
                      v-for="(role, role_key) in user.roles"
                      :key="role_key"
                      :title="role.description"
                      class="user_budge__item"
                  >
                    {{ role.name }}
                  </span>
                </div>
              </td>
              <td
                  :data-label="translate('user.last_try_ts')"
                  :style="'color:' + last_try_date(user.last_try_ts)?.color"
                  class="tdFont w10per text-right"
              >
                {{ last_try_date(user.last_try_ts)?.date }}
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EditProfile from "./UserProfile/EditUserProfile.vue";

export default {
  name: "UserList",
  props: ["role_list", "permission_list"],
  components: {},
  data() {
    return {
      load: true,
      user_list: [],
      init: false,
      filter: {
        searched_user: "",
        status: "",
        client_id: null,
      },
      check_link: true,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    };
  },
  updated: function () {
    this.$nextTick(function () {
      this.init = true;
    });
  },

  activated() {
    this.get_users();
  },
  deactivated() {
    this.$modal.hide('user_profile_modal')
  },
  mounted() {
    this.get_users();
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        if (this.$route.name === "user_management_section") {
          let string = "?";
          for (let key in this.filter) {
            if (this.filter[key]) {
              string += "&" + key + "=" + this.filter[key];
            }
          }
          history.pushState(null, null, this.$route.path + string);
        }
      },
    },
  },

  computed: {
    users(){
      let user_list = [...this.user_list];
      return user_list.sort(this.compareNumbers);
    },
    client_list() {
      let list = [];
      if (this.$store.getters.getClientsList.length > 0) {
        list = this.$store.getters.getClientsList.map((client) => {
          return { id: client.id, label: client.name };
        });
      }
      return list;
    },
    client_ids() {
      return this.$store.getters.getClientsList;
    },
    user_status() {
      return [
        { id: "", label: "all" },
        { id: 1, label: "active" },
        { id: 0, label: "blocked" },
      ];
    },
  },

  methods: {
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_users, 500)
    },
    last_try_date(last_try_ts){
      if (!last_try_ts) return

      let now = Math.round(+new Date()/1000)
      let diff = now - last_try_ts
      if (diff < 60*60*24*30){ //если разница меньше 30 дней
        return {color: "#66615b", date: this.get_date(last_try_ts)}
      }else if (diff > 60*60*24*30*3){ //если разница больше 90 дней
        return {color: "#b84141", date: this.get_date(last_try_ts)}
      }else{ //если от 30 до 90 дней
        return {color: "#F3BB45", date: this.get_date(last_try_ts)}
      }
    },
    clear_filter(){
      this.filter = {
        searched_user: "",
        status: "",
        client_id: null,
      };
    },
    user_client(client_id) {
      let name = "";
      if (client_id) {
        for (let client of this.client_ids) {
          if (client.id === client_id) {
            name = client.name;
          }
        }
      }
      return name;
    },

    user_groups(groups_id) {
      let all_groups = this.$store.getters.getDeviceGroups;
      let users_group = [];
      if (groups_id) {
        for (let group_id of groups_id) {
          for (let group of all_groups) {
            if (group.id === group_id) users_group.push(group.name);
          }
        }
      }
      return users_group;
    },

    new_user(val) {
      if (Object.keys(val).length === 0) {
        val = {
          active: 1,
          email: "",
          client_id: null,
          name: "",
          phone: "",
          username: "",
        };
      }
      var t = this.$createElement(EditProfile, {
        props: {
          user: val,
          role_list: this.role_list,
          permission_list: this.permission_list,
        },
        on: {
          close: () => {
            this.$modal.hide("user_profile_modal");
            this.check_link = true;
          },
          update: () => {
            this.get_users();
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
        temp,
        {},
        {
          height: 800,
          width: 800,
          adaptive: true,
          clickToClose: true,
          name: "user_profile_modal",
        }
      );
    },

    get_users() {
      let filter = {}
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== ""){
          filter[key] = this.filter[key]
        }
      })
      this.$http.v1.getUsersList(filter, (response) => {
        this.load = false;
        this.init = false;
        this.user_list = response.data;
      });
    },
    check_query() {
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case 'client_id':
              this.filter[key] = Number(this.$route.query[key])
              break;
            case "status":
            case 'searched_user':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },
};
</script>

<style lang="scss" scoped>

.user_list{
  display: flex;
  flex-direction: column;
  padding-top: 30px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex: 1;

  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .search_user {
      margin-bottom: 0;
    }
    .select {
      width: 50%;
      margin: 0 10px;
    }
    &_item {
      flex: 1;
      margin: 0 5px;
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: 0;
      }
      .vue-treeselect {
        margin-bottom: 0;
      }
    }
  }
  .buttons {
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;

    .btn {
      padding: 0 5px;
      margin-bottom: 5px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.response_table {
  padding: 10px 0;
  th.text-left, td.text-left {
    text-align: left;
  }
  th.text-right, td.text-right {
    text-align: right;
  }
  th, td, th *, td * {
    font-size: 12px;
  }
}
.card_table {
  table {
    tbody {
      &::-webkit-scrollbar {
        width: 10px;
      }
    }
  }
}

.user {
  td{
    vertical-align: middle;
    color: #252422;
  }
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }

  &_budge {
    min-height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    &__item {
      background: #fff;
      border: 1px solid #ddd;
      padding: 1px 4px;
      border-radius: 5px;
      margin: 0 3px 3px 0;
    }
  }
}

@media (max-width: 768px) {
  .header {
    align-items: flex-end;
    .filter {
      flex-direction: column;
      &_item {
        width: 100%;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .search_user {
        width: 100%;
      }
    }
    .buttons {
      flex-direction: column;
      .btn {
        width: 100%;
      }
      .reset_filter {
        margin-bottom: 25px;
      }
    }
  }
}

@media (max-width: 750px) {
  .user {
    &_groups {
      justify-content: space-between;
    }
  }
}

@media (max-width: 500px) {
  .header {
    flex-direction: column;
    .filter {
      margin-bottom: 10px;
      &_item {
        margin: 2.5px 0;
      }
    }
    .buttons {
      width: 100%;
      .reset_filter {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
